import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { useField, useFormikContext } from 'formik'
import { useCallback, useEffect, useMemo } from 'react'
import { LeadAssignmentRuleFormModel } from '../../../../typings'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
type Props = {
  name: string
  salesFunnelStages: ISalesFunnelStage[]
  required: boolean
}

export function useData(props: Props) {
  const { name, salesFunnelStages, required } = props
  const options = salesFunnelStages
  const tidalThemeActive = useTidalThemeActive()
  const { setFieldValue, isSubmitting, values } =
    useFormikContext<LeadAssignmentRuleFormModel>()

  const salesFunnelStageId = useMemo(() => values[name], [values, name])

  const [{}, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const getLabel = useCallback(
    (option: ISalesFunnelStage) => `${option?.name}`,
    [],
  )

  const getId = useCallback((option: ISalesFunnelStage) => {
    return String(option.id)
  }, [])

  const initialOption = useMemo(() => {
    if (salesFunnelStageId) {
      const value = options.find((x) => x.id === parseInt(salesFunnelStageId))
      if (value) return value
    }
    return null
  }, [options, salesFunnelStageId])

  useEffect(() => {
    if (salesFunnelStageId == '' && initialOption) {
      setFieldValue(name, initialOption.id)
    }
  }, [salesFunnelStageId, initialOption, setFieldValue, name])
  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'
  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
    density,
  }
}
